import * as React from "react"
import PropTypes from "prop-types"

import { useStaticQuery, graphql, withPrefix } from "gatsby"

import Helmet from "react-helmet"
import SEO from "../components/seo"

import { Autoplay, Navigation, Pagination, A11y } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"

import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import "swiper/css/scrollbar"

const Slider = ({ site }) => {
  const query = useStaticQuery(graphql`
    query Slider {
      allStrapiSlides {
        edges {
          node {
            Titulo_uno
            TItulo_dos
            Contenido_uno
            Contenido_dos
            Contenido
            provider
            link
            site
            image {
              url
            }
          }
        }
      }
    }
  `)

  let url_global = process.env.GATSBY_API_URL
  const projects = query.allStrapiSlides.edges

  return (
    <>
      <SEO title="Slider" />
      <Helmet>
        <script src="https://code.jquery.com/jquery-1.12.4.min.js"></script>
        <script src={withPrefix("js/script.js")} type="text/javascript" />
      </Helmet>
      <div>
        <Swiper
          centeredSlides={true}
          spaceBetween={30}
          autoplay={{
            delay: 6000,
            // delay: 1000000000,
            //disableOnInteraction: true,
          }}
          tabIndex="1"
          style={{ maxHeight: "61rem", marginTop: "6rem" }}
          slidesPerView="auto"
          pagination={{
            clickable: true,
          }}
          navigation
          modules={[Autoplay, Pagination, Navigation, A11y]}
        >
          {projects.map(({ node: project }, index) => {
            if (project.site === site && project.provider === "Imagen") {
              return (
                <SwiperSlide
                  key={index + project}
                  className="ajustar_tamano_slide"
                  style={{
                    height: "63rem",
                    width: "100% !important",
                  }}
                  tabIndex="1"
                >
                  <div
                    className="recuadro_slide_degradado"
                    style={{
                      display: "none",
                    }}
                  ></div>
                  <img
                    className="shadow-xl ubicar_slider"
                    src={url_global + project.image[0].url}
                    alt={`${project.Titulo_uno} ${project.Titulo_dos}`}
                    title={`${project.Titulo_uno} ${project.Titulo_dos}`}
                    style={{
                      width: "100%",
                      position: "relative",

                      bottom: "5rem",
                    }}
                    formats={["auto", "webp", "avif"]}
                  />
                  <div
                    className="relative container mx-auto px-14 margen_total_titulo_contenido_slide"
                    style={{ marginTop: "-34rem" }}
                  >
                    <div className="mx-auto container flex flex-col w-full md:items-start px-6 tracking-wide alinear_texto_slide">
                      <div
                        className="container mx-auto text-black my-4 font-black uppercase tamano_texto_slide"
                        style={{ fontSize: "2.5rem", lineHeight: "2rem" }}
                      >
                        <p
                          className="text-poppins-extra_bold text-green-default tamano_titulo_slide"
                          style={{ fontSize: "3rem" }}
                        >
                          {project.Titulo_uno} {""}
                        </p>
                        <p
                          className="text-poppins-extra_bold text-green-light tamano_titulo_dos_slide"
                          style={{ fontSize: "2.9rem", lineHeight: "1" }}
                        >
                          {project.TItulo_dos}
                        </p>
                      </div>
                      <div
                        className="mitexto_color text-poppins-regular color-texto-parrafo text-base my-4 text-gray-500 tamano_contenido_slide"
                        style={{
                          width: "80%",
                          lineHeight: "1.5rem",

                          bottom: "1rem",
                          position: "relative",
                        }}
                      >
                        <p
                          className="texo_slide font-black text-poppins-extra_bold"
                          style={{ fontSize: "20px" }}
                        >
                          {project.Contenido_uno}
                        </p>{" "}
                        <p className="texo_slide" style={{ fontSize: "20px" }}>
                          {project.Contenido_dos}
                        </p>
                      </div>
                      <div
                        className="alinear_texto_info"
                        style={{
                          textAlign: "left",
                          position: "relative",
                        }}
                      >
                        <a
                          className="text-poppins-black-italic inline-block leading-relaxed text-black italic text-lg tamano_texto_info"
                          href={project.link}
                          target="_self"
                        >
                          <span style={{ color: "#248443" }}>+</span>
                          <span className="text-green-light">INFO</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              )
            }
          })}
        </Swiper>
      </div>
    </>
  )
}

Slider.propTypes = {
  siteTitle: PropTypes.string,
}

Slider.defaultProps = {
  siteTitle: ``,
}

export default Slider
